import { Region } from '@coveo-platform/private-platform-client';
import validator from 'validator';
import { URLConstant } from '../constants/URLConstant.js';
import { RegionHelper } from './RegionHelper.js';
import { ENVIRONMENT } from '../types/EnvironmentType.js';
var getEnvFromDocumentURL = function getEnvFromDocumentURL(origin, region) {
    var parameters = new URLSearchParams(window.location.search);
    // look for the env in the querystring Should only be used when debugging
    for(var currentEnvironment in URLConstant.UI_HOSTNAMES){
        if (Object.prototype.hasOwnProperty.call(URLConstant.UI_HOSTNAMES, currentEnvironment)) {
            for(var i = 0; i < URLConstant.UI_HOSTNAMES[currentEnvironment].length; i++){
                if (parameters.get(URLConstant.UI_HOSTNAMES[currentEnvironment][i]) !== null) {
                    return currentEnvironment;
                }
            }
        }
    }
    // real lookup of the environment
    for(var currentEnvironment1 in URLConstant.UI_HOSTNAMES){
        if (Object.prototype.hasOwnProperty.call(URLConstant.UI_HOSTNAMES, currentEnvironment1)) {
            for(var i1 = 0; i1 < URLConstant.UI_HOSTNAMES[currentEnvironment1].length; i1++){
                var isOriginUs = origin.includes('-us') && region === Region.US;
                if (origin.includes(RegionHelper.injectRegion(URLConstant.UI_HOSTNAMES[currentEnvironment1][i1], region, isOriginUs))) {
                    return currentEnvironment1;
                }
            }
        }
    }
    return ENVIRONMENT.local;
};
var getServiceUrl = function getServiceUrl(env, region, queryParam, defaultEndpoint) {
    var parameters = new URLSearchParams(window.location.search);
    var paramValue = parameters.get(queryParam);
    var allowedHosts = [
        /\.cloud\.coveo\.com$/
    ];
    if (env === ENVIRONMENT.dev) {
        allowedHosts.push('localhost');
        allowedHosts.push(/\.corp\.coveo\.com$/);
        allowedHosts.push(/\.stratus\.coveo\.com$/);
    }
    // We need to validate that the param is a URL and controlled by Coveo,
    // otherwise it can be used for XSS or to proxy requests and steal data
    if (paramValue && validator.isURL(paramValue, {
        require_valid_protocol: true,
        host_whitelist: allowedHosts
    })) {
        var anchor = new URL(paramValue);
        return "".concat(anchor.protocol, "//").concat(anchor.host);
    }
    if (typeof defaultEndpoint === 'string') {
        return RegionHelper.injectRegion(defaultEndpoint, region);
    }
    if (Array.isArray(defaultEndpoint)) {
        return defaultEndpoint.map(function(endpoint) {
            return RegionHelper.injectRegion(endpoint, region);
        });
    }
    return '';
};
var getApplicationBaseUrls = function getApplicationBaseUrls(env) {
    return {
        'commerce-hub': URLConstant.APPLICATION_COMMERCE_HUB_BASE_URL[env],
        'knowledge-hub': URLConstant.APPLICATION_KNOWLEDGE_HUB_BASE_URL[env],
        'admin-ui': URLConstant.APPLICATION_PLATFORM_BASE_URL[env],
        docs: URLConstant.ONLINE_HELP_BASE_URL[env]
    };
};
export var URLHelper = {
    getEnvFromDocumentURL: getEnvFromDocumentURL,
    getServiceUrl: getServiceUrl,
    getApplicationBaseUrls: getApplicationBaseUrls
};

//# sourceMappingURL=URLHelper.js.map